import { render, staticRenderFns } from "./AppPreviewWidget.vue?vue&type=template&id=f56f0624&scoped=true&"
import script from "./AppPreviewWidget.vue?vue&type=script&lang=js&"
export * from "./AppPreviewWidget.vue?vue&type=script&lang=js&"
import style0 from "./AppPreviewWidget.vue?vue&type=style&index=0&id=f56f0624&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56f0624",
  null
  
)

export default component.exports